import React, { useState, useEffect } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { HealthServiceDataViewStatus } from './HealthStatusService'
import { deepClone } from '../../../utils/clone'

const HealthStatusServiceOptionsRisk = ({ data }) => {

    //console.log(data)

    const tab_col = [
        {
            field: "id",
            headerName: "Account ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 200,
            suppressSizeToFit: true,
            cellStyle: function (params) {
                if (params.value !== 'UP') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
    ]

    const [tab_data, settab_data] = useState([])
    useEffect(() => {
        settab_data(Object.keys(data).sort((a, b) => (data[a].status === 'UP') ? 1 : -1).reduce((rowData, rowId) => {
            const row = deepClone(data[rowId])
            rowData.push({
                'uniqueId': row.id,
                'id': row.id,
                'status': row.status,
            })
            return rowData
        }, []))
    }, [data])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Accounts </Text>
                <HealthServiceDataViewStatus tab_data={tab_data.map(function (item) { return item["status"] })} />
            </Box>
            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceOptionsRisk"
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceOptionsRisk